// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, sans-serif;
}

.title h3{
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: left;
  }

.dropdown-container {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-top: 20px;
}

.dropdown-container label {
    margin-right: 10px;
}
.button-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}
table th {
    background-color: #0b2d71 !important;
    color: white;
    font-weight: bold;
}

th, td {
    border: 1px solid white;
    text-align: center;
    padding: 8px;
}

th {
    background-color: #0b2d71;
    font-weight: bold;
}

#department, #division, #orderby {
    height: 35px;
    width: 215px;
}

label[for="orderby"], label[for="division"], label[for="department"] {
    padding: 30px;
    margin-top: 10px;
}
label[for="department"]{
    padding-left: 1px;
}

.order-by-container {
    display: flex;
    align-items: center;
    gap: 10px;
}
.error-message {
    color: red;
    font-weight: bold;
    margin-top: 10px;
  }
  td a {
    color: blue;
    text-decoration: none; 
  }
.file-container {
    border:1px solid  #d3d3d3;
    border-radius:1px;
    margin:3% 0%;
    max-width: 100%;
}
.bordered-container {
    border: 1px solid #d3d3d3; 
    padding: 20px;
    max-width: 100%;
    margin: 3% 0%;
    border-radius: 1px;
    
  }
.color{
    color: #0b2d71;
  }`, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/bydepartmentdivision/bydepartmentdivision.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;AAEF;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;AACF;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,aAAa;IACb,kBAAkB;;EAEpB;AACF;IACI,cAAc;EAChB","sourcesContent":["body {\n    font-family: Arial, sans-serif;\n}\n\n.title h3{\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: left;\n  }\n\n.dropdown-container {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.dropdown-container label {\n    margin-right: 10px;\n}\n.button-container {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\ntable th {\n    background-color: #0b2d71 !important;\n    color: white;\n    font-weight: bold;\n}\n\nth, td {\n    border: 1px solid white;\n    text-align: center;\n    padding: 8px;\n}\n\nth {\n    background-color: #0b2d71;\n    font-weight: bold;\n}\n\n#department, #division, #orderby {\n    height: 35px;\n    width: 215px;\n}\n\nlabel[for=\"orderby\"], label[for=\"division\"], label[for=\"department\"] {\n    padding: 30px;\n    margin-top: 10px;\n}\nlabel[for=\"department\"]{\n    padding-left: 1px;\n}\n\n.order-by-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.error-message {\n    color: red;\n    font-weight: bold;\n    margin-top: 10px;\n  }\n  td a {\n    color: blue;\n    text-decoration: none; \n  }\n.file-container {\n    border:1px solid  #d3d3d3;\n    border-radius:1px;\n    margin:3% 0%;\n    max-width: 100%;\n}\n.bordered-container {\n    border: 1px solid #d3d3d3; \n    padding: 20px;\n    max-width: 100%;\n    margin: 3% 0%;\n    border-radius: 1px;\n    \n  }\n.color{\n    color: #0b2d71;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
